<template lang="pug">
  div.restaurant-listing
    public-navbar
    div.restaurants-page
      
      v-parallax(
        src="/img/banner-bg.png"
        :height="$vuetify.breakpoint.smAndDown ? 300 : 360"
      )
        .banner-shape
          img(src='/img/banner-shape.svg', :height="$vuetify.breakpoint.smAndDown ? 300 : 400")
        v-container(fill-height)
          v-row(align="center" justify="center")
            v-col(cols="12" md="8" class="text-center")
              h3.text-h6.font-weight-bold.white--text.text-shadow(:class="$vuetify.breakpoint.smAndDown ? 'mb-4' : 'mb-8'")
                | Comprá comida 
                span.text-h6.font-weight-bold.text-shadow.board--text en los mejores restaurantes de tu ciudad
              v-row(justify="center" align="center")
                v-col(cols="5" sm="5")
                  // Selector de ubicación reutilizable
                  location-selector(dark :show-chip="true" @changed="onLocationChanged")
                v-col(cols="7" sm="7")
                  v-text-field(
                    v-model="search"
                    label="Buscar restaurantes..."
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    dense
                    dark
                    hide-details
                    background-color="rgba(255,255,255,0.15)"
                    class="search-field"
                  )
    // Main Content
    v-container(class="py-6")
      // Category Carousel
      v-row(class="mb-2 no-gutters")
        v-col(cols="12")
          v-slide-group(
            show-arrows
            center-active
          )
            // Botón para limpiar filtro: Todos
            v-slide-item(v-slot="{ active }")
              v-btn.mr-1(
                :class="{ 'active-category': !selectedCategory }"
                :color="!selectedCategory ? 'primary' : ''"
                text
                rounded
                outlined
                small
                @click="selectedCategory = null"
              )
                v-icon(left :color="!selectedCategory ? 'white' : 'primary'") mdi-format-list-bulleted
                span Todos ({{ totalCount }})
            v-slide-item(
                v-for="category in categories"
                :key="category.id"
                v-slot="{ active }"
            )
              v-btn.mr-1(
                :class="{ 'active-category': selectedCategory?._id === category._id }"
                :color="selectedCategory?._id === category._id ? 'primary' : ''"
                text
                rounded
                outlined
                small
                @click="selectCategory(category)"
              )
                v-icon(left :color="selectedCategory?._id === category._id ? 'white' : 'primary'") {{ category.icon }}
                span {{ category.name }} ({{ categoryCounts[category._id] || 0 }})
      // Quick Filters
      v-row(class="mb-0 no-gutters")
        v-col(cols="12")
          v-slide-group(show-arrows center-active)
            v-slide-item(v-slot="{ active }")
              v-btn.mr-1(
                text
                rounded
                small
                outlined
                :color="showOnlyOpen ? 'primary' : ''"
                @click="showOnlyOpen = !showOnlyOpen"
              )
                span Abiertos
            v-slide-item(v-slot="{ active }")
              v-btn.mr-1(
                text
                rounded
                small
                outlined
                :color="sortByDistance ? 'primary' : ''"
                @click="handleSortByDistanceClick"
              )
                span Mas cerca
            v-slide-item(v-slot="{ active }")
              v-btn.mr-1(
                text
                rounded
                small
                outlined
                :color="sortByRating ? 'primary' : ''"
                @click="sortByRating = !sortByRating"
              )
                span Populares
            v-slide-item(v-slot="{ active }")
              v-btn.mr-1(
                text
                rounded
                small
                outlined
                :color="showOnlyDelivery ? 'primary' : ''"
                @click="showOnlyDelivery = !showOnlyDelivery"
              )
                span Entrega a domicilio
      // Restaurant Cards Grid
      template(v-if="loading")
        transition-group(name="fade" tag="div" class='row')
            // Skeleton Loaders
            v-col(
              v-for="n in 6"
              :key="`skeleton-${n}`"
              cols="12"
              sm="6"
              md="4"
              lg="4"
              xl="3"
            )
              v-card.restaurant-card(outlined height="220")
                v-skeleton-loader(
                  type="image"
                  height="120"
                )
                v-card-text.pa-3
                  v-row(no-gutters)
                    v-col(cols="12")
                      v-skeleton-loader(
                        type="text"
                        class="mb-2"
                      )
                    v-col(cols="12")
                      v-row(no-gutters align="center")
                        v-col(cols="8")
                          v-skeleton-loader(
                            type="text"
                            width="60%"
                          )
                        v-col(cols="4")
                          v-skeleton-loader(
                            type="text"
                            width="100%"
                          )
                    v-col(cols="12")
                      v-row(no-gutters align="center" class="mt-2")
                        v-col(cols="6")
                          v-skeleton-loader(
                            type="chip"
                            width="80%"
                          )
                        v-col(cols="6" class="text-right")
                          v-skeleton-loader(
                            type="chip"
                            width="80%"
                          )
      template(v-else-if="filteredRestaurants.length === 0")
        v-row(justify="center" class="mt-6")
          v-col(cols="12" class="text-center")
            v-img(
              src="@/assets/images/no-reservations.svg"
              max-width="200"
              class="mx-auto mb-4"
            )
            h3.text-h6.mb-2 No hay restaurantes disponibles
            p.text-body-2.grey--text No se encontraron restaurantes en {{ currentCity || 'tu ubicación' }}. Por favor, intenta con otra ubicación.
      template(v-else)
        transition-group(name="fade" tag="div" class='row')
          // Restaurant Cards (contenido actual)
          v-col(
            v-for="restaurant in filteredRestaurants"
            :key="restaurant._id"
            cols="12"
            sm="6"
            md="4"
            lg="4"
            xl="3"
          )
            v-hover(v-slot="{ hover }")
                v-card.restaurant-card.rounded-lg(
                  :class="{ 'restaurant-inactive': !restaurant.isActive }"
                  :to="`/r/${restaurant.urlSlug}`"
                  @click="handleCardClick($event, restaurant)"
                )
                  // Imagen principal con gradiente
                  v-img.restaurant-image(
                    :src='restaurant.coverImage'
                    :gradient="restaurant.isActive ? 'to bottom, rgba(0,0,0,.0), rgba(0,0,0,.7)' : 'to bottom, rgba(0,0,0,.2), rgba(0,0,0,.8)'"
                    height='200'
                    :class="{ 'restaurant-image--inactive': getStatusText(restaurant) !== 'Abierto' }"
                  )
                    // Share Button flotante
                    v-btn.share-btn-absolute(
                      icon
                      x-small
                      color="white"
                      elevation="1"
                      @click.stop.prevent="shareRestaurant($event, restaurant)"
                    )
                      v-icon(size="18") mdi-share-variant
                    // Logo Avatar
                    v-avatar.restaurant-logo(
                      size="56"
                      class="ma-3"
                    )
                      v-img(
                        :src="restaurant.logo"
                        :alt="`${restaurant.name} logo`"
                      )
                    // Información principal
                    v-row.fill-height.align-end.no-gutters
                      v-col
                        .pa-3
                          .d-flex.justify-space-between.align-center
                            .restaurant-title
                              .text-h5.white--text.font-weight-bold.text-truncate {{ restaurant.name }}
                              .subtitle-1.white--text.text-truncate {{ restaurant.description }}
                  v-card-text
                    v-row(align="center" no-gutters)
                      v-col(cols="12")
                        .d-flex.align-center.justify-space-between
                          // Estado y Rating
                          .d-flex.align-center
                            // Estado (abierto/cerrado/inactivo
                            v-icon(left x-small :color="getStatusColor(restaurant)") {{ getStatusIcon(restaurant) }}
                            | {{ getStatusText(restaurant) }}
                          // Rating
                          .d-flex.align-right
                            v-icon(small color="amber darken-2") mdi-star
                            a.ml-1.caption.grey--text(style='align-self: center')
                              | {{ getRestaurantRating(restaurant) }}
                            v-divider(vertical class="mx-2")
                            // Instagram
                            v-btn(
                              v-if="getInstagramUrl(restaurant)"
                              icon
                              small
                              :href="getInstagramUrl(restaurant)"
                              target="_blank"
                              @click.stop
                            )
                              v-icon(color="#E1306C") mdi-instagram
                            v-divider(vertical class="mx-2" v-if="getInstagramUrl(restaurant)")
                            v-btn(icon small @click.stop.prevent="toggleFavorite(restaurant)")
                              v-icon(:color="isFavorite(restaurant._id) ? '#f24847' : '#f24847'")
                                | {{ isFavorite(restaurant._id) ? 'mdi-heart' : 'mdi-heart-outline' }}
                      v-col(cols="12")
                        // Info de delivery y tiempo
                        .d-flex.align-center.justify-space-between
                          .d-flex.align-center
                              v-icon(left small) {{ restaurant.categories[0].icon }}
                              | {{ restaurant.categories[0].name }} {{ restaurant.categories[1] ? `y ${restaurant.categories[1].name}` : '' }}
                          .d-flex.align-right
                            v-icon(small color="grey darken-1") mdi-clock-outline
                            span.ml-1.caption.grey--text.text--darken-1 {{ getDeliveryTime(restaurant) }} min
                            v-divider(vertical class="mx-2")
                            v-icon(small color="grey darken-1") mdi-bike
                            span.ml-1.caption.grey--text.text--darken-1
                              | {{ getMinDeliveryCostDisplay(restaurant) }}
      // Loading Skeleton
      template(v-if="loading")
        v-row
          v-col(
            v-for="n in 6"
            :key="n"
            cols="12"
            sm="6"
            md="4"
          )
            v-skeleton-loader(
              type="card"
              :loading="true"
            )
      // Bottom Sheet Filters (Mobile)
      v-bottom-sheet(v-model="showFilters" scrollable)
        v-card
          v-toolbar(dark color="primary")
            v-toolbar-title Filtros
            v-spacer
            v-btn(icon dark @click="showFilters = false")
              v-icon mdi-close
          v-card-text(style="height: 400px")
            v-row
              v-col(cols="12")
                v-select(
                  v-model="filters.priceRange"
                  :items="priceRanges"
                  label="Rango de precios"
                  multiple
                  chips
                  small-chips
                  outlined
                )
              v-col(cols="12")
                v-select(
                  v-model="filters.cuisine"
                  :items="cuisineTypes"
                  label="Tipo de cocina"
                  multiple
                  chips
                  small-chips
                  outlined
                )
              v-col(cols="12")
                v-select(
                  v-model="filters.distance"
                  :items="distanceOptions"
                  label="Distancia máxima"
                  outlined
                )
              v-col(cols="12")
                v-switch(
                  v-model="filters.delivery"
                  label="Con delivery"
                  color="primary"
                  inset
                )
              v-col(cols="12")
                v-switch(
                  v-model="filters.openNow"
                  label="Abierto ahora"
                  color="success"
                  inset
                )
          v-card-actions
            v-spacer
            v-btn(
              color="primary"
              block
              @click="showFilters = false"
            ) Aplicar Filtros
    v-dialog(v-model="showVerificationDialog" max-width="500")
      v-card
        v-card-title.headline Iniciar sesión
        v-card-text
          phone-verification(
            @verification-success="onVerificationSuccess"
            @verification-error="showVerificationDialog = false"
          )
  </template>
  
  <script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import PublicNavbar from '@/components/layout/PublicNavbar.vue'
  import PhoneVerification from '@/components/dialogs/WhatsappVerification.vue'
  import AddressIcon from '@/assets/icons/AddressIcon.vue'
  import LocationSelector from '@/components/location/LocationSelector.vue'

  export default {
    name: 'RestaurantListing',
  
    components: {
      PublicNavbar,
      PhoneVerification,
      AddressIcon,
      LocationSelector
    },
  
    data: () => ({
      search: '',
      mobileMenuOpen: false,
      locationSearch: '',
      selectedLocation: null,
      showFilters: false,
      selectedFilters: [],
      filters: {
        priceRange: [],
        cuisine: [],
        minRating: 0,
        distance: null,
        delivery: false,
        openNow: false
      },
      priceRanges: [
        { text: 'Económico ($)', value: 1 },
        { text: 'Moderado ($$)', value: 2 },
        { text: 'Premium ($$$)', value: 3 }
      ],
      cuisineTypes: [
        'Italiana',
        'Argentina',
        'Mexicana',
        'China',
        'Japonesa',
        'Vegetariana',
        'Vegana',
        'Parrilla',
        'Pizzería',
        'Hamburguesería'
      ],
      distanceOptions: [
        { text: '1 km', value: 1 },
        { text: '3 km', value: 3 },
        { text: '5 km', value: 5 },
        { text: '10 km', value: 10 }
      ],
      showLocationDialog: false,
      tempCity: null,
      loading: false,
      selectedCategory: null,
      hideNavbar: false,
      showVerificationDialog: false,
      restaurantToFavorite: null,
      userLocation: null,
      showOnlyOpen: false,
      sortByDistance: false,
      sortByRating: false,
      showOnlyDelivery: false,
    }),
  
    computed: {
      ...mapState({
        restaurants: state => state.restaurant.list,
        categories: state => state.restaurant.categories,
        gettingLocation: state => state.location.gettingLocation,
        locationError: state => state.location.locationError,
        currentCity: state => state.location.currentCity,
      }),
      ...mapGetters('restaurant', ['getMinDeliveryCost', 'getRestaurantReviewStats']),
      ...mapGetters('auth', ['isAuthenticatedCustomer']),
      ...mapGetters('customer', ['isFavorite']),
      
      // Conteo de restaurantes por categoría (por _id)
      categoryCounts() {
        const counts = {}
        const list = Array.isArray(this.restaurants) ? this.restaurants : []
        list.forEach(r => {
          if (Array.isArray(r.categories)) {
            r.categories.forEach(c => {
              const id = c?._id
              if (!id) return
              counts[id] = (counts[id] || 0) + 1
            })
          }
        })
        return counts
      },

      totalCount() {
        return Array.isArray(this.restaurants) ? this.restaurants.length : 0
      },
  
      filteredRestaurants() {
        // Partimos del listado y encadenamos filtros por restaurante
        let result = Array.isArray(this.restaurants) ? [...this.restaurants] : []

        // Ocultar restaurantes que no tengan ni delivery ni takeaway habilitados
        result = result.filter(r => r?.salesMethods?.delivery === true || r?.salesMethods?.takeaway === true)

        // Abiertos
        if (this.showOnlyOpen) {
          result = result.filter(r => this.getStatusText(r) === 'Abierto')
        }

        // Solo delivery
        if (this.showOnlyDelivery) {
          result = result.filter(r => r?.salesMethods?.delivery === true)
        }

        // Texto de búsqueda
        if (this.search) {
          const q = this.search.toLowerCase()
          result = result.filter(r =>
            r?.name?.toLowerCase().includes(q) ||
            r?.description?.toLowerCase().includes(q)
          )
        }

        // Rango de precio
        if (this.filters.priceRange && this.filters.priceRange.length) {
          result = result.filter(r => this.filters.priceRange.includes(r.priceRange))
        }

        // Tipo de cocina
        if (this.filters.cuisine && this.filters.cuisine.length) {
          result = result.filter(r => this.filters.cuisine.includes(r.cuisine))
        }

        // Rating mínimo
        if (this.filters.minRating) {
          result = result.filter(r => (typeof r.rating === 'number' ? r.rating : 0) >= this.filters.minRating)
        }

        // Con delivery requerido
        if (this.filters.delivery) {
          result = result.filter(r => r?.salesMethods?.delivery === true)
        }

        // Abierto ahora
        if (this.filters.openNow) {
          result = result.filter(r => this.isRestaurantOpen(r))
        }

        // Categoría seleccionada
        if (this.selectedCategory && this.selectedCategory._id) {
          const catId = this.selectedCategory._id
          result = result.filter(r => Array.isArray(r.categories) && r.categories.some(c => c._id === catId))
        }

        // Ordenamientos
        if (this.sortByRating) {
          result = [...result].sort((a, b) => {
            const ratingA = typeof a.rating === 'number' ? a.rating : 0
            const ratingB = typeof b.rating === 'number' ? b.rating : 0
            return ratingB - ratingA
          })
        } else if (this.sortByDistance && this.userLocation) {
          const restaurantsWithDistance = result.map(restaurant => {
            const distance = this.getDistance(this.userLocation, restaurant.location)
            return { ...restaurant, distance }
          })
          result = restaurantsWithDistance.sort((a, b) => a.distance - b.distance)
        }

        return result
      }
    },
  
    methods: {
      ...mapActions({
        fetchRestaurants: 'restaurant/fetchAll',
        fetchCategories: 'restaurant/fetchCategories',
        setCurrentCity: 'location/setCurrentCity',
        getLocationFromStore: 'location/getCurrentLocation',
        getNewLocation: 'location/getNewLocation',
        saveLocation: 'location/saveLocation',
        setCoordinates: 'location/setCoordinates',
        fetchLocationByCoordinates: 'location/fetchByCoordinates',
        setUserLocation: 'location/setUserLocation',
        toggleFav: 'favorites/toggleRestaurant',
        showNotification: 'notifications/showNotification'
      }),
      ...mapActions('restaurant', ['fetchNeighborhoods']),
      ...mapActions('auth', ['checkAuthCustomer']),
      ...mapActions('customer', ['addFavorite', 'removeFavorite', 'fetchFavoriteIds']),
      
      onLocationChanged({ location }) {
        if (location && typeof location.lat === 'number' && typeof location.lng === 'number') {
          this.userLocation = { lat: location.lat, lng: location.lng }
        }
        // Refrescar listado usando provincia/ciudad del store actualizados por el LocationSelector
        this.fetchRestaurantsForCurrentProvince()
      },

      async fetchRestaurantsForCurrentProvince() {
        try {
          const currentProvince = this.$store.state.location.currentProvince
          const currentCity = this.$store.state.location.currentCity
          if (currentProvince) {
            const params = { province: currentProvince }
            if (currentCity) params.city = currentCity
            await this.fetchRestaurants(params)
          } else {
            await this.fetchRestaurants()
          }
        } catch (error) {
          console.error('Error fetching restaurants by province:', error)
          this.$toast && this.$toast.error('No pudimos actualizar el listado de restaurantes')
        }
      },
  
      goToMenu(restaurant) {
        this.$router.push(`/r/${restaurant.urlSlug}`)
      },
  
      isRestaurantOpen(restaurant) {
        // If restaurant is not active, it's closed
        if (!restaurant.isActive) return false

        // Get current day and time
        const now = new Date()
        const currentDay = now.getDay() // 0 (Sunday) to 6 (Saturday)
        const currentTime = now.getHours() * 60 + now.getMinutes() // time in minutes

        // Check if restaurant has a schedule for this day
        const daySchedule = restaurant.schedule[currentDay]

        // If no schedule or day is not open, restaurant is closed
        if (!daySchedule || !daySchedule.open) return false

        // Convert open and close times to minutes
        const [openHours, openMinutes] = daySchedule.openTime.split(':').map(Number)
        const [closeHours, closeMinutes] = daySchedule.closeTime.split(':').map(Number)
        const openTimeMinutes = openHours * 60 + openMinutes
        const closeTimeMinutes = closeHours * 60 + closeMinutes

        // Check if current time is within open hours
        // Handle cases that cross midnight
        if (closeTimeMinutes < openTimeMinutes) {
          return currentTime >= openTimeMinutes || currentTime < closeTimeMinutes
        }

        return currentTime >= openTimeMinutes && currentTime < closeTimeMinutes
      },

      timeToMinutes(timeStr) {
        if (!timeStr) return 0;
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours * 60 + minutes;
      },

      getStatusColor(restaurant) {
        if (!restaurant.isActive) return 'grey';
        return this.isRestaurantOpen(restaurant) ? 'success' : 'error';
      },

      getStatusIcon(restaurant) {
        if (!restaurant.isActive) return 'mdi-power-off';
        return this.isRestaurantOpen(restaurant) ? 'mdi-check-circle' : 'mdi-clock-outline';
      },

      getStatusText(restaurant) {
        if (!restaurant.isActive) return 'No disponible'
        
        if (!this.isRestaurantOpen(restaurant)) {
          const nextOpenTime = this.getNextOpenTime(restaurant);
          return nextOpenTime ? `Abre ${nextOpenTime}` : 'Cerrado';
        }
        
        return 'Abierto';
      },

      getNextOpenTime(restaurant) {
        if (!restaurant.schedule || !restaurant.schedule.length) return null;

        const now = new Date();
        const currentDay = now.getDay();
        const currentTime = now.getHours() * 60 + now.getMinutes();

        // Ordenar horarios por día, comenzando desde el día actual
        const sortedSchedule = [...restaurant.schedule]
          .sort((a, b) => {
            const aDiff = (a.day - currentDay + 7) % 7;
            const bDiff = (b.day - currentDay + 7) % 7;
            return aDiff - bDiff;
          });

        // Buscar el próximo horario de apertura
        for (const schedule of sortedSchedule) {
          const openTime = this.timeToMinutes(schedule.openTime);
          
          if (schedule.day === currentDay) {
            // Para el día actual, solo considerar si el tiempo de apertura es futuro
            if (openTime > currentTime) {
              return 'a las ' + schedule.openTime;
            }
          } else {
            // Para otros días, mostrar el día y la hora
            const days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
            return `el ${days[schedule.day]} a las ${schedule.openTime}`;
          }
        }

        // Si no encontramos un próximo horario, usar el primer horario disponible
        if (sortedSchedule.length > 0) {
          const firstSchedule = sortedSchedule[0];
          const days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
          return `el ${days[firstSchedule.day]} a las ${firstSchedule.openTime}`;
        }

        return null;
      },

      getSocialIcon(network) {
        const icons = {
          instagram: 'mdi-instagram',
          facebook: 'mdi-facebook',
          twitter: 'mdi-twitter',
          whatsapp: 'mdi-whatsapp'
        }
        return icons[network] || 'mdi-link'
      },
  
      getSocialColor(network) {
        const colors = {
          instagram: '#E1306C',
          facebook: '#4267B2',
          twitter: '#1DA1F2',
          whatsapp: '#25D366'
        }
        return colors[network] || 'grey'
      },
  
      async toggleFavorite(restaurant) {
        if (!this.isAuthenticatedCustomer) {
          this.restaurantToFavorite = restaurant
          this.showVerificationDialog = true
          return
        }

        try {
          if (this.isFavorite(restaurant._id)) {
            await this.removeFavorite(restaurant._id)
            this.$toast.success(`${restaurant.name} eliminado de favoritos`)
          } else {
            await this.addFavorite(restaurant._id)
            this.$toast.success(`${restaurant.name} agregado a favoritos`)
          }
        } catch (error) {
          console.error('Error toggling favorite:', error)
          this.$toast.error('Error al actualizar favoritos')
        }
      },

      handleCardClick(e, restaurant) {
        if (!restaurant.isActive) {
          this.$toast.info(this.getInactiveMessage(restaurant))
        }
      },
  
      getInactiveMessage(restaurant) {
        if (!restaurant.deactivationConfig) return 'Temporalmente cerrado'
        
        if (restaurant.deactivationConfig.isTemporary && restaurant.deactivationConfig.endTime) {
          const endTime = new Date(restaurant.deactivationConfig.endTime)
          const timeStr = endTime.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })
          return `Vuelve a las ${timeStr}`
        }
        
        return restaurant.deactivationConfig.reason || 'No disponible por el momento'
      },
  
      getMinDeliveryCostDisplay(restaurant) {
        return restaurant.deliveryCosts?.displayText || 'No disponible'
      },

      getInstagramUrl(restaurant) {
        if (!restaurant?.socialMedia?.instagram?.active) return null
        const url = restaurant.socialMedia.instagram.url
        if (!url) return null
        return url.startsWith('http') ? url : `https://instagram.com/${url.replace('@', '')}`
      },

      getRestaurantRating(restaurant) {
        return restaurant.rating ? `${restaurant.rating}` : 'Sin reseñas';
      },

      getDeliveryTime(restaurant) {
        if (!restaurant.schedule || !restaurant.schedule.length) return '--';

        const now = new Date();
        const currentDay = now.getDay();
        const currentTime = now.getHours() * 60 + now.getMinutes();

        // Buscar horario para el día actual
        const todaySchedule = restaurant.schedule.find(schedule => schedule.day === currentDay);
        if (!todaySchedule) return '--';

        // Si el restaurante está cerrado, mostrar el tiempo estimado del próximo horario
        if (!this.isRestaurantOpen(restaurant)) {
          const nextSchedule = this.getNextSchedule(restaurant);
          return nextSchedule ? nextSchedule.estimatedDeliveryTime : '--';
        }

        // Verificar si estamos en horario pico
        const isPeakTime = this.isPeakHour(currentTime, todaySchedule);
        return isPeakTime ? 
          todaySchedule.estimatedDeliveryTime + 15 : // Agregar 15 minutos en horario pico
          todaySchedule.estimatedDeliveryTime;
      },

      getNextSchedule(restaurant) {
        if (!restaurant.schedule || !restaurant.schedule.length) return null;

        const now = new Date();
        const currentDay = now.getDay();
        const currentTime = now.getHours() * 60 + now.getMinutes();

        // Ordenar horarios comenzando desde el día actual
        const sortedSchedule = [...restaurant.schedule]
          .sort((a, b) => {
            const aDiff = (a.day - currentDay + 7) % 7;
            const bDiff = (b.day - currentDay + 7) % 7;
            return aDiff - bDiff;
          });

        // Buscar el próximo horario disponible
        for (const schedule of sortedSchedule) {
          const openTime = this.timeToMinutes(schedule.openTime);
          
          if (schedule.day === currentDay) {
            // Para el día actual, solo considerar si el tiempo de apertura es futuro
            if (openTime > currentTime) {
              return schedule;
            }
          } else {
            // Para otros días, mostrar el día y la hora
            return schedule;
          }
        }

        return sortedSchedule[0];
      },

      isPeakHour(currentTime, schedule) {
        // Definir horarios pico (por ejemplo: 12:00-14:00 y 20:00-22:00)
        const peakHours = [
          { start: this.timeToMinutes('13:00'), end: this.timeToMinutes('14:00') },
          { start: this.timeToMinutes('21:00'), end: this.timeToMinutes('22:30') }
        ];

        return peakHours.some(peak => 
          currentTime >= peak.start && currentTime <= peak.end
        );
      },
  
      async handleSortByDistanceClick() {
        if (this.userLocation) {
          this.sortByDistance = !this.sortByDistance;
        } else {
          await this.getCurrentLocation();
          if (this.userLocation) {
            this.sortByDistance = true;
          }
        }
      },
      getDistance(userLoc, restLoc) {
        if (!userLoc || !restLoc) return Infinity;
        
        // Verificar si restLoc tiene la estructura esperada o si es del modelo MongoDB
        let restLat, restLng;
        
        if (restLoc.coordinates && Array.isArray(restLoc.coordinates)) {
          // Formato MongoDB: [longitude, latitude]
          restLng = restLoc.coordinates[0];
          restLat = restLoc.coordinates[1];
        } else if (restLoc.lat && restLoc.lng) {
          // Formato {lat, lng}
          restLat = restLoc.lat;
          restLng = restLoc.lng;
        } else {
          // No hay coordenadas válidas
          return Infinity;
        }
        
        // Si alguna coordenada no es un número válido, devolver infinito
        if (isNaN(restLat) || isNaN(restLng) || 
            isNaN(userLoc.lat) || isNaN(userLoc.lng)) {
          return Infinity;
        }
        
        const toRad = x => x * Math.PI / 180;
        const R = 6371; // Radio de la Tierra en km
        const dLat = toRad(restLat - userLoc.lat);
        const dLon = toRad(restLng - userLoc.lng);
        const lat1 = toRad(userLoc.lat);
        const lat2 = toRad(restLat);
        const a = Math.sin(dLat/2) ** 2 +
                  Math.sin(dLon/2) ** 2 * Math.cos(lat1) * Math.cos(lat2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        return R * c;
      },
  
      async confirmLocation() {
        if (!this.locationSearch) {
          this.$store.commit('location/SET_LOCATION_ERROR', 'Por favor ingresa una ciudad');
          return;
        }

        try {
          // Agregar ", Argentina" a la búsqueda si no lo tiene ya para forzar resultados argentinos
          let searchQuery = this.locationSearch;
          if (!searchQuery.toLowerCase().includes('argentina')) {
            searchQuery += ', Argentina';
          }
          
          // Usar la API de Google Maps para geocodificación
          const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
              searchQuery
            )}&key=${process.env.VUE_APP_GOOGLE_MAPS_KEY}&language=es&region=AR&components=country:AR`
          );
          const data = await response.json();

          if (data.status === 'OK' && data.results.length > 0) {
            // Filtrar primero para verificar que es un resultado de Argentina
            const argentineResults = data.results.filter(result => {
              return result.address_components.some(component => 
                component.short_name === 'AR' && 
                component.types.includes('country')
              );
            });
            
            // Si no hay resultados de Argentina específicamente, usar el primer resultado
            const result = argentineResults.length > 0 ? argentineResults[0] : data.results[0];
            const location = result.geometry.location;
            
            // Buscar el componente de ciudad en los resultados
            const cityComponent = result.address_components.find(
              component => component.types.includes('locality')
            );
            
            // Buscar el componente de provincia/estado
            const provinceComponent = result.address_components.find(
              component => component.types.includes('administrative_area_level_1')
            );
            
            const city = cityComponent ? cityComponent.long_name : this.locationSearch;
            const province = provinceComponent ? provinceComponent.long_name : '';
            
            // Guardar en el store
            await this.setCurrentCity(city);
            if (province) {
              this.$store.commit('location/SET_CURRENT_PROVINCE', province);
            }
            
            // Guardar la ubicación en el store
            const locationData = {
              latitude: location.lat,
              longitude: location.lng
            };
            this.$store.commit('location/SET_CURRENT_LOCATION', locationData);
            
            // Actualizar variables locales
            this.locationSearch = city;
            this.userLocation = {
              lat: location.lat,
              lng: location.lng
            };
            
            this.showLocationDialog = false;
            
            // Actualizar búsqueda de restaurantes
            await this.fetchRestaurants();
          } else {
            this.$store.commit('location/SET_LOCATION_ERROR', 'No se encontró la ubicación');
          }
        } catch (error) {
          console.error('Error al confirmar ubicación:', error);
          this.$store.commit('location/SET_LOCATION_ERROR', 'Error al actualizar la ubicación');
        }
      },
      async checkSavedLocation() {
        const savedLocation = localStorage.getItem('currentLocation')
        if (savedLocation) {
          const locationData = JSON.parse(savedLocation)
          const savedCity = localStorage.getItem('currentCity')
          const savedProvince = localStorage.getItem('currentProvince')
          const now = Date.now()
          const ONE_DAY = 24 * 60 * 60 * 1000
          
          // Verificar si hay un timestamp guardado
          const savedTime = localStorage.getItem('currentLocationTime')
          const isValid = savedTime && (now - parseInt(savedTime)) < ONE_DAY

          if (savedCity && locationData && (isValid || !savedTime)) {
            this.userLocation = {
              lat: locationData.lat ?? locationData.latitude,
              lng: locationData.lng ?? locationData.longitude
            }
            return true
          }
        }
        return false
      },
      async getCurrentLocation() {
        try {
          // Usar la acción del store para obtener SIEMPRE la ubicación actual
          const locationData = await this.getNewLocation();
          
          if (locationData) {
            // Actualizar las variables locales
            this.locationSearch = locationData.city;
            this.userLocation = {
              lat: locationData.location.latitude,
              lng: locationData.location.longitude
            };
            
            this.showLocationDialog = false;
            
            // Actualizar búsqueda de restaurantes con la nueva ciudad
            await this.fetchRestaurantsForCurrentProvince();
          }
        } catch (error) {
          console.error('Error al obtener ubicación:', error);
          // Usar toast para mostrar error en lugar de una acción inexistente
          this.$toast.error('No se pudo obtener tu ubicación. Por favor, habilitá el acceso a la ubicación en tu navegador.');
        }
      },
      closeLocationDialog() {
        this.showLocationDialog = false;
        this.locationSearch = this.currentCity; // Restaurar el valor anterior
        this.$store.commit('location/SET_LOCATION_ERROR', null);
      },
      selectCategory(category) {
        // If the same category is clicked again, deselect it
        this.selectedCategory = this.selectedCategory?._id === category._id ? null : category
      },
      handleScroll() {
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        this.hideNavbar = scrollPosition > windowHeight * 0.05;
      },
      onVerificationSuccess() {
        this.showVerificationDialog = false
        if (this.restaurantToFavorite) {
          this.toggleFavorite(this.restaurantToFavorite)
          this.restaurantToFavorite = null
        }
      },
      shareRestaurant(e, restaurant) {
        // Evitar la navegación al restaurante cuando se presiona el botón
        e.stopPropagation()
        e.preventDefault()
        
        // Construir la URL completa para compartir
        const restaurantUrl = `${window.location.origin}/r/${restaurant.urlSlug}`
        
        // Copiar al portapapeles
        navigator.clipboard.writeText(restaurantUrl)
          .then(() => {
            // Mostrar mensaje de éxito
            this.showNotification({ 
              text: 'URL del restaurante copiada al portapapeles', 
              color: 'success' 
            })
          })
          .catch(err => {
            console.error('Error al copiar URL: ', err)
            this.showNotification({ 
              text: 'No se pudo copiar la URL. Intentá nuevamente.', 
              color: 'error' 
            })
          })
      },
    },
  
    watch: {
      locationSearch() {
        if (this.locationError) {
          this.locationError = null;
        }
      },
      '$store.state.location.currentProvince': {
        handler() {
          this.fetchRestaurantsForCurrentProvince()
        }
      },
      '$store.state.location.currentCity': {
        handler() {
          this.fetchRestaurantsForCurrentProvince()
        }
      }
    },

    async created() {
      try {
        // Intentar usar ubicación guardada primero
        const hasSavedLocation = await this.checkSavedLocation()
        
        if (!hasSavedLocation) {
          // Si no hay ubicación guardada, intentar obtener la ubicación actual
          await this.getCurrentLocation()
        } else {
          // Si hay ubicación guardada, cargar restaurantes filtrados por provincia/ciudad
          await this.fetchRestaurantsForCurrentProvince()
        }

        // Categorías y favoritos (independientes de la ubicación)
        await this.fetchCategories()
        if (this.isAuthenticatedCustomer) {
          this.fetchFavoriteIds()
        }

        this.loading = false
      } catch (error) {
        console.error('Error loading initial data:', error);
        this.$toast.error('Error al cargar los datos iniciales');
      }
    }
  }
  </script>
  
  <style scoped>
  span.text-h6.font-weight-bold.text-shadow {
    color: #832828;
}
  .theme--light.v-app-bar.v-toolbar.v-app-bar.v-sheet {
    background-color: #f5f5f500;
  }
  .restaurant-listing {
    background-color: #f5f5f5;
    min-height: 97vh;
  }
  
  .restaurant-card-wrapper {
    padding: 8px;
  }
  
  .restaurant-card {
    position: relative;
    transition: all 0.3s ease;
    overflow: hidden;
    border-radius: 12px;
  }
  
  .restaurant-card:hover {
    transform: translateY(-4px);
  }
  
  .restaurant-inactive {
    filter: grayscale(0.3);
  }
  
  .restaurant-inactive:hover {
    transform: translateY(-2px);
  }
  
  .restaurant-logo {
    position: absolute;
    top: 0;
    left: 0;
    border: 2px solid white;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }
  
  .favorite-btn {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  
  .restaurant-title {
    text-shadow: 0 2px 4px rgba(0,0,0,0.4);
    max-width: calc(100% - 48px);
  }
  
  .v-rating .v-icon {
    padding: 0;
  }
  .theme--light.v-btn.v-btn--icon {
    color: rgb(0 0 0 / 0%);
  }
  /* Animación suave para el botón de favoritos */
  .favorite-btn .v-icon {
    transition: transform 0.3s ease;
  }
  
  .favorite-btn:hover .v-icon {
    transform: scale(1.2);
  }
  
  /* Touch targets for mobile */
  @media (max-width: 600px) {
    .v-input__append-outer {
        display: none!important;
    }
    .v-chip {
      height: 30px !important;
    }
    h3.text-h6.font-weight-bold.white--text.text-shadow.mb-4 {
      font-size: 1.25rem!important;
      padding-top: 30px!important;
    }
    p.text-h6.white--text.text-shadow {
        font-size: 1rem !important;
    }
  }
  h3.text-h6.font-weight-bold.white--text.text-shadow.mb-4 {
    padding-top: 60px;
  }
  /* Pull to refresh styles */
  .v-overlay--scroll-blocked {
    overflow-y: hidden !important;
  }
  
  /* Skeleton loading animation */
  .v-skeleton-loader {
    border-radius: 12px;
  }
  
  /* Infinite scroll trigger */
  .infinite-loading-container {
    margin: 24px 0;
  }
  .restaurants-page {
    margin-top: 0;
  }
  .banner-shape {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
}
header.v-sheet.theme--light.elevation-1.v-toolbar.v-app-bar {
    box-shadow: none !important;
    border: none;
}
.v-parallax__content {
    padding-top: 60px;
}
.v-icon.amber.darken-2 {
  color: #ffd600 !important;
}
.location-chip {
  height: 40px !important;
  border: 1px solid #e0e0e0 !important;
  
  .v-icon {
    &.mdi-map-marker {
      color: #fff !important;
    }
  }
  
  .location-text {
    color: rgba(0, 0, 0, 0.87);
    font-weight: 500;
  }
}

.v-menu__content {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.v-parallax::v-deep label.v-label.theme--dark {
    font-size: 0.8rem;
}
.restaurant-card {
  transition: transform 0.2s;
  
  &:hover {
    transform: translateY(-4px);
  }

  .v-skeleton-loader {
    border-radius: 4px;
    
    &::v-deep .v-skeleton-loader__text {
      margin-bottom: 8px !important;
    }
    
    &::v-deep .v-skeleton-loader__chip {
      height: 24px !important;
    }
  }
}
.share-btn-absolute {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  background: rgba(0,0,0,0.4);
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}
.restaurant-image {
  position: relative;
}
.restaurant-image--inactive {
  filter: grayscale(1) brightness(0.9);
  transition: filter 0.3s;
}
i.v-icon.notranslate.v-icon--left.theme--light.white--text::before {
    color: #ba0808!important;
}
  </style>